import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import MaterialSelector from './../MaterialSelector';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { interior_view04ImageOptions } from './views/interior_view04'

class Xc47OwnersCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsChange = this.handleCupboardsChange.bind(this);
        this.handleFabricChange = this.handleFabricChange.bind(this);
        this.handleBedsideCompartmentChange = this.handleBedsideCompartmentChange.bind(this);
        this.handleWardrobeChange = this.handleWardrobeChange.bind(this);
    }


    handleCupboardsChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsOwnersCabin = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricOwnersCabin = newValue;
        configuration.FabricFreehung = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }




    handleBedsideCompartmentChange(event) {
        let configuration = this.props.configuration;
        configuration.BedsideCompartment = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleWardrobeChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Wardrobe = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {

        let imageOptions = interior_view04ImageOptions;

        let image = <ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />;


        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Owner’s cabin' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Large wardrobe to starboard is standard.' /></p>

                    <RadioGroup options={this.props.WardrobeOptions} value={this.props.configuration.Wardrobe} onChange={this.handleWardrobeChange} />

                    <Toggle checked={this.props.configuration.CupboardsOwnersCabin.value === 2} onChange={this.handleCupboardsChange}>
                        <Trans defaults='Upper freeboard cabinets above the berth (port & starboard)' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.BedsideCompartment.value === 2} onChange={this.handleBedsideCompartmentChange}>
                        <Trans defaults='Bedside compartment with lid with integrated higher bed support at sea' />
                    </Toggle>


                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricOwnersCabin.label} value={this.props.configuration.FabricOwnersCabin} onChange={this.handleFabricChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47OwnersCabin);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47OwnersCabin.js